import { render, staticRenderFns } from "./StudentBio.vue?vue&type=template&id=552b9764&"
import script from "./StudentBio.vue?vue&type=script&lang=js&"
export * from "./StudentBio.vue?vue&type=script&lang=js&"
import style0 from "./StudentBio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports